import { apiGetQuizzesResults, apiGetQuizzesListResults, apiGetQuizzesListAllResults } from "../api/QuizzesApi";
import { GET_QUIZZES_RESULTS_DATA, GET_QUIZZES_RESULTS_DATA_FAILED, GET_QUIZZES_RESULTS_LIST_DATA, GET_QUIZZES_RESULTS_LIST_DATA_FAILED, GET_QUIZZES_RESULTS_LIST_ALL_DATA, GET_QUIZZES_RESULTS_LIST_ALL_DATA_FAILED } from "./types";

export const getQuizzesResults = (data, type) => async dispatch => {
    try {
        let response = await apiGetQuizzesResults(data, type);

        // console.log(`getQuizzesResults \ndata: `, data, `\nresponse: `,response)

        dispatch({
            type: GET_QUIZZES_RESULTS_DATA,
            payload: response
        });
    } catch (error) {
        dispatch({
            type: GET_QUIZZES_RESULTS_DATA_FAILED, 
            payload: error
        });
    }
};

export const getQuizzesListResults = (data, type) => async dispatch => {
    try {
        let response = await apiGetQuizzesListResults(data, type);

        console.log(`getQuizzesListResults \ndata: `, data, `\nresponse: `,response)

        dispatch({
            type: GET_QUIZZES_RESULTS_LIST_DATA,
            payload: response
        });
    } catch (error) {
        dispatch({
            type: GET_QUIZZES_RESULTS_LIST_DATA_FAILED,
            payload: error
        });
    }
};

export const getQuizzesListAllResults = (data, type) => async dispatch => {
    try {
        let response = await apiGetQuizzesListAllResults(data, type);

        console.log(`getQuizzesListAllResults \ndata: `, data, `\nresponse: `,response)

        dispatch({
            type: GET_QUIZZES_RESULTS_LIST_ALL_DATA,
            payload: response
        });
    } catch (error) {
        dispatch({
            type: GET_QUIZZES_RESULTS_LIST_ALL_DATA_FAILED,
            payload: error
        });
    }
};